import { Component, Input, Output, forwardRef } from '@angular/core'
import { 
  ControlValueAccessor,
  NG_VALUE_ACCESSOR, 
  FormControl,
  ValidatorFn,
  Validators
} from '@angular/forms';
import * as _ from 'lodash'

import { Center, City, Country } from 'models'

const CENTERS_SELECT_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CentersSelectComponent),
  multi: true
};

@Component({
  template: require('./centers-select.component.html'),
  selector: 'centers-select',
  styles: [require('./centers-select.component.sass')],
  providers: [
    CENTERS_SELECT_VALUE_ACCESSOR
  ]
})

export class CentersSelectComponent implements ControlValueAccessor {
  @Input('value') private value: number[] 
  @Input('centers') private centers: Center[] = []
  @Input('cities') private cities: City[] = []
  @Input('countries') private countries: Country[] = []

  // dd options
  cityOptions: Object[] = []
  centerOptionsIndex: { [key: number]: Object[] } = {}
  // vars
  selectedCityIds: number[] = []
  selectedCenterIdsIndex: { [key: number]: number[] } = {}
  addCityId: number
  private _value: number[] = []

  // ControlValueAccessor interface -->
  propagateChange:any = () => {};
  onTouchedCallback:any = () => {};
  validateFn:any = () => {};

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }

  writeValue(value: any) {
    this._value = value;
    this.updateSelectedIds()
    this.buildCityOptions()
    this.buildCenterOptions()
  }

  validate(c: FormControl) {
    return this.validateFn(c);
  }
  // <-- ControlValueAccessor interface

  private onSelectedCityChange(event: Object) {
    let cityId = event['value']
    let previousCityId = event['previousValue']
    let index = this.selectedCityIds.indexOf(previousCityId)
    
    this.selectedCityIds[index] = cityId
    delete this.selectedCenterIdsIndex[previousCityId]
    this.selectedCenterIdsIndex[cityId] = []
    this.updateSelectedCenterIds()
    this.updateDisabledCityOptions()
    this.propagateChange(this._value)
  }

  private onAddCityChange(event: Object) {
    if (!event['value']){return} 
    this.selectedCityIds.push(this.addCityId)
    this.selectedCenterIdsIndex[this.addCityId] = []
    this.updateDisabledCityOptions()
    setTimeout(() => {
      this.addCityId = null
    }, 0)
  }

  private onSelectedCentersChange(event: Object) {
    this.updateSelectedCenterIds()
    this.onTouchedCallback()
  }

  private buildCityOptions() {
    let result = []
    for (let country of this.countries) {
      let cities = this.cities.filter(city => {
        return city.countryId == country.id && (!city.disabled() || this.selectedCityIds.indexOf(city.id) > -1)
      })

      if (country.disabled()) {
        cities = cities.filter(city => this.selectedCityIds.indexOf(city.id) > -1)
      }

      if (cities.length == 0) continue 

      let cityOptions = cities.map(city => ({ value: city.id, label: city.name }))

      result.push({
        label: country.name,
        group: true,
        subOptions: cityOptions
      })
    }
    this.cityOptions = result
  }

  private buildCenterOptions() {
    let centers = this.centers.filter(center => !center.disabled() || this._value.indexOf(center.id) > -1)
    let result = this.cities.reduce((hash, city) => {

      hash[city.id] = centers
        .filter(center => center.cityId == city.id)
        .map(center => ({ 
          value: center.id, 
          label: center.name,
          subLabel: center.comment
        }))
      return hash
    }, {})
    this.centerOptionsIndex = result
  }

  private updateSelectedIds() {
    this.selectedCityIds = []
    this.selectedCenterIdsIndex = {}
    let centers = this.centers.filter(c => this._value.indexOf(c.id) > -1)
    for (let center of _.sortBy(centers, 'cityName')) {
      if (this.selectedCityIds.indexOf(center.cityId) == -1) {
        this.selectedCityIds.push(center.cityId)
      }
      if (!this.selectedCenterIdsIndex[center.cityId]) {
        this.selectedCenterIdsIndex[center.cityId] = []
      }
      this.selectedCenterIdsIndex[center.cityId].push(center.id)
    }
  }

  private updateSelectedCenterIds() {
    this._value = _.flatten(_.values(this.selectedCenterIdsIndex))
    this.propagateChange(this._value)
  }

  private updateDisabledCityOptions() {
    for (let countryOption of this.cityOptions) {
      for (let cityOption of countryOption['subOptions']) {
        cityOption['disabled'] = this.selectedCityIds.indexOf(cityOption['value']) > -1
      }
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/forms/centers-select.component.ts